module.exports = __webpack_public_path__ + "static/media/Shellfish.cb349de7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/Shellfish.svg
// module id = 1121
// module chunks = 0